export function slugifyHeading(heading: string) {
  return heading
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace space with dash
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple dashes with single dash
    .replace(/^-|-$/g, ""); // Remove trailing and leading dashes
}
